import ApiBaseService from './ApiBaseService.js';

class AdminService {

    static getAuthProfile() {
        return ApiBaseService.request(`/api/auth/profile`, 'GET');
    }

    static listCompanies([pagination = 0, page = 0, limit = 0, searchText = '']) {
        return ApiBaseService.request(`/api/company?pagination=${pagination}&page=${page}&limit=${limit}&search=${searchText}`, 'GET');
    }

    static getEmployees([pagination = 0, company_uuid, page, limit = 0, searchText = '', filter = 'all']) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee?pagination=${pagination}&page=${page}&limit=${limit}&search=${searchText}&filter=${filter}`, "GET");
    }
    static changeStatusCompany([company_uuid, status]) {
        return ApiBaseService.request(`api/company/${company_uuid}/status/${status}`, "GET");
    }
    static change2FAStatusCompany([company_uuid, enableStatus]) {
        return ApiBaseService.request(`api/company/${company_uuid}/mfa/${enableStatus}`, "GET");
    }
    static downloadCompany([data]) {
        return ApiBaseService.request(`api/company/download`, "GET", data);
    }

    // admin users
    static listAdminUsers([pagination = 0, page = 0, limit = 0, searchText = '', filter = 'all', filterNew = 'all']) {
        return ApiBaseService.request(`api/admin/user?pagination=${pagination}&page=${page}&limit=${limit}&search=${searchText}&filter=${filter}&filter-new=${filterNew}`, "GET");
    }
    static getAdminUserByUuid([user_uuid]) {
        return ApiBaseService.request(`api/admin/user/${user_uuid}`, "GET");
    }
    static createAdminUser([data]) {
        return ApiBaseService.request(`api/admin/user`, "POST", data);
    }
    static updateAdminUser([user_uuid, data]) {
        return ApiBaseService.request(`api/admin/user/${user_uuid}`, "PUT", data);
    }
    static changeAdminUserStatus([user_uuid, status]) {
        return ApiBaseService.request(`api/admin/user/${user_uuid}/status/${status}`, "PUT", {});
    }
    static changeAdminUser2FaStatus([user_uuid, enableStatus]) {
        return ApiBaseService.request(`api/admin/user/${user_uuid}/mfa/${enableStatus}`, "GET", {});
    }
    static sendUserCredentials([user_uuid]) {
        return ApiBaseService.request(`api/admin/user/${user_uuid}/credentials`, "PUT", {});
    }

    // support tickets
    static getSupportCases([status, pagination = 0, page = 0, limit = 0, searchText]) {
        return ApiBaseService.request(`api/admin/ticket?status=${status}&pagination=${pagination}&page=${page}&limit=${limit}&search=${searchText}`, 'GET');
    }
    static getSupportHistory([case_uuid, pagination = 0, page = 0, limit = 0]) {
        return ApiBaseService.request(`api/admin/ticket-history/${case_uuid}?pagination=${pagination}&page=${page}&limit=${limit}`, 'GET');
    }
    static saveSupportHistory([case_uuid, data]) {
        return ApiBaseService.request(`api/admin/ticket-history/${case_uuid}`, 'POST', data);
    }
    static changeSupportCaseStatus([case_uuid, data]) {
        return ApiBaseService.request(`api/admin/ticket-history/${case_uuid}`, 'PUT', data);
    }
    static createTicketMessage([case_uuid, data]) {
        return ApiBaseService.request(`api/admin/ticket/${case_uuid}`, 'POST', data);
    }

    // enquiries
    static getEnquiryList([filter, filterNew, pagination = 0, page = 0, limit = 0, searchText]) {
        return ApiBaseService.request(`api/admin/lead?filter-new=${filterNew}&filter=${filter}&pagination=${pagination}&page=${page}&limit=${limit}&search=${searchText}`, 'GET');
    }
    static getEnquiryDetail([enquiry_uuid]) {
        return ApiBaseService.request(`api/admin/lead/${enquiry_uuid}`, 'GET');
    }
    static deleteEnquiry([enquiry_uuid]) {
        return ApiBaseService.request(`api/admin/lead/${enquiry_uuid}`, 'DELETE');
    }
    static createEnquiryMessage([enquiry_uuid, data]) {
        return ApiBaseService.request(`api/admin/lead/${enquiry_uuid}`, 'POST', data);
    }
    static getEnquiryHistory([enquiry_uuid, pagination = 0, page = 0, limit = 0]) {
        return ApiBaseService.request(`api/admin/lead-history/${enquiry_uuid}?pagination=${pagination}&page=${page}&limit=${limit}`, 'GET');
    }

    //CA
    static getCaList([pagination = 0, page = 0, limit = 0, searchText = "", filter = ""]) {
        return ApiBaseService.request(`api/admin/ca?filter=${filter}&pagination=${pagination}&page=${page}&limit=${limit}&search=${searchText}`, 'GET');
    }
    static getCa([userUUID]) {
        return ApiBaseService.request(`api/admin/ca/${userUUID}`, 'GET');
    }
    static createCa([data]) {
        return ApiBaseService.request(`api/admin/ca`, 'POST', data);
    }

    static getCaUSer([userUUID]) {
        return ApiBaseService.request(`api/admin/ca/${userUUID}`, 'GET');
    }
    static updateCa([userUUID, data]) {
        return ApiBaseService.request(`api/admin/ca/${userUUID}`, 'PUT', data);
    }
    static updateCaStatus([userUUID, status]) {
        return ApiBaseService.request(`api/admin/ca/${userUUID}/status/${status}`, 'PUT');
    }
    static updateCaMfaStatus([userUUID, mfaStatus]) {
        return ApiBaseService.request(`api/admin/ca/${userUUID}/mfa/${mfaStatus}`, 'GET');
    }
    static sendCaCredentials([user_uuid]) {
        return ApiBaseService.request(`api/admin/ca/${user_uuid}/credentials`, "PUT", {});
    }

    static downloadCa() {
        return ApiBaseService.request(`api/admin/ca-download`, "GET");
    }
    // static caCompanyList() {
    //     return ApiBaseService.request(`api/company`, "GET");
    // }
    static caCompanyList([ca_uuid]) {
        return ApiBaseService.request(`api/company/?ca=${ca_uuid}`, "GET");
    }
    static caCompany([companyUuid]) {
        return ApiBaseService.request(`api/company/${companyUuid}`, "GET");
    }
    // static updateCa([userUUID, data]) {
    //     return ApiBaseService.request(`api/admin/ca/${userUUID}`, 'PUT', data);
    // }

    static associate([caUuid, companyUuid, data]) {
        return ApiBaseService.request(`api/admin/ca/${caUuid}/company/${companyUuid}`, 'POST', data);
    }
    static disAssociate([caUuid, companyUuid, data]) {
        return ApiBaseService.request(`api/admin/ca/${caUuid}/company/${companyUuid}`, 'PUT', data);
    }
    static associateFromComany([caUuid, companyUuid, data]) {
        return ApiBaseService.request(`api/admin/company/${companyUuid}/ca/${caUuid}`, 'POST', data);
    }
    static disAssociateFromCompany([caUuid, companyUuid, data]) {
        return ApiBaseService.request(`api/admin/company/${companyUuid}/ca/${caUuid}`, 'PUT', data);
    }


}

export default AdminService;
